<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-clinic-search />
<p-confirmDialog key="clinicSavedMsg" [style]="{ width: '700px' }"></p-confirmDialog>
